import { Office } from '../models/office.model';

export function alphabeticSort(a, b) {
  const collator = new Intl.Collator();
  return collator.compare(a, b);
}

export function getBusinessFromOffice(office: Office): string[] {
  const business: string[] = [];
  switch (office.companyId) {
    case 'FUN':
    case 'RWS':
    case 'RPS':
    case 'VEX':
    case 'RIS':
    case 'AND':
      business.push('STAF');
      break;

    case 'RID':
      switch (office.regionId.toString()) {
        case '37':
        case '35':
          business.push('STAF');
          break;
        default:
          break;
      }
      break;

    case 'INT':
      switch (office.randstadOffice.toString()) {
        case '1':
          business.push('STAF');
          break;
        case '2':
          business.push('PROF');
          break;
        case '3':
        case '20':
        case '21':
          business.push('STAF');
          business.push('PROF');
          business.push('TECH');
          break;
      }

    default:
      switch (office.regionId.toString()) {
        case '31':
        case '33':
        case '35':
        case '36':
        case '40':
        case '41':
        case '58':
        case '67':
          business.push('PROF');
          business.push('TECH');
          break;
        case '32':
          business.push('STAF');
          business.push('PROF');
          business.push('TECH');
          break;
        case '9':
        case '09': // OTP's Staffing
          switch (office.randstadOffice) {
            case 6319:
              business.push('PROF');
              break;
            default:
              business.push('STAF');
          }
          break;
        default:
          break;
      }
      break;
  }
  return business;
}

export function getBusinessIdsFromBussiness(businesses: string[]): number[] {

  const businessIds: number[] = [];

  if (businesses) {
    businesses.map(business => {
      switch (business) {
        case 'STAF':
          businessIds.push(1);
          break;
        case ('PROF'):
        case ('TECH'):
          businessIds.push(2);
          break;
        default:
          break;
      }
    });
  }

  return businessIds;
}
